import React, {useEffect, useState, useCallback} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {Grid, Divider, Button, Dialog, DialogContent, DialogContentText, DialogTitle, TextField, FormControl, Select, MenuItem, InputLabel, Box, AlertTitle, IconButton} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import FormHelperText from '@mui/material/FormHelperText'
import Spinner from 'react-bootstrap/Spinner'
import {Formik, useFormikContext} from 'formik'
import {useSelector, useDispatch} from 'react-redux'
import * as Member from '../../store/ducks/member.duck'
import FileUploadIcon from '@mui/icons-material/FileUploadOutlined'
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers-pro'
import {AdapterDayjs} from '@mui/x-date-pickers-pro/AdapterDayjs'
import {useDropzone} from 'react-dropzone'
import dayjs from 'dayjs'
import * as Yup from 'yup'
import CloseIcon from '@mui/icons-material/Close'
import {FormLabel} from 'react-bootstrap'

const diagnosisAdditionalOptions = {
  'Accident/Injury': [{value: 'Other', label: 'Other - Please specify the exact date of the accident and resulting injuries'}],
  'Allergy Disorders': [
    {value: 'Environmental Allergies - dust, pet hair or dander, mites, etc.', label: 'Environmental Allergies - dust, pet hair or dander, mites, etc.'},
    {value: 'Food Allergies - seafood, dairy, nuts etc.', label: 'Food Allergies - seafood, dairy, nuts etc.'},
    {value: 'Injections or Medication', label: 'Injections or Medication'},
    {value: 'Seasonal Allergies - pollen, ragweed, etc.', label: 'Seasonal Allergies - pollen, ragweed, etc.'},
    {value: 'Sneezing, itchy nose, and/or congestion', label: 'Sneezing, itchy nose, and/or congestion'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Cardiac Disorders': [
    {value: 'Chest Pain', label: 'Chest Pain'},
    {value: 'Fainting/Loss of consciousness', label: 'Fainting/Loss of consciousness'},
    {value: 'Heart arrhythmia', label: 'Heart arrhythmia'},
    {value: 'Heart Attack', label: 'Heart Attack'},
    {value: 'Heart Disease', label: 'Heart Disease'},
    {value: 'Other', label: 'Other - Please specify'}
  ],
  'Digestive Disorders': [
    {value: 'Abdominal Pain', label: 'Abdominal Pain'},
    {value: 'Colon polyps', label: 'Colon polyps'},
    {value: 'Constipation', label: 'Constipation'},
    {value: "Crohn's Disease", label: "Crohn's Disease"},
    {value: 'Diarrhea', label: 'Diarrhea'},
    {value: 'Irritable Bowel Syndrome (IBS)', label: 'Irritable Bowel Syndrome (IBS)'},
    {value: 'Nausea and/or Vomiting', label: 'Nausea and/or Vomiting'},
    {value: 'Pelvic Pain', label: 'Pelvic Pain'},
    {value: 'Reflux', label: 'Reflux'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Ear/Nose/Throat Disorders': [
    {value: 'Bacterial Infection - Strep', label: 'Bacterial Infection - Strep'},
    {value: 'Build up of ear wax', label: 'Build up of ear wax'},
    {value: 'Cough, common cold, and/or congestion', label: 'Cough, common cold, and/or congestion'},
    {value: 'Ear Infection', label: 'Ear Infection'},
    {value: 'Hearing Loss', label: 'Hearing Loss'},
    {value: 'Impacted Teeth', label: 'Impacted Teeth'},
    {value: 'Sinus Infection', label: 'Sinus Infection'},
    {value: 'Tonsillitis', label: 'Tonsillitis'},
    {value: 'Upper Respiratory Infection', label: 'Upper Respiratory Infection'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Endocrine Disorders': [
    {value: 'Diabetes', label: 'Diabetes'},
    {value: 'High Cholesterol', label: 'High Cholesterol'},
    {value: 'Obesity', label: 'Obesity'},
    {value: 'Thyroid Disorder', label: 'Thyroid Disorder'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Eye Disorders': [
    {value: 'Cataracts', label: 'Cataracts'},
    {value: 'Conjunctivitis or pink eye', label: 'Conjunctivitis or pink eye'},
    {value: 'Dry Eyes', label: 'Dry Eyes'},
    {value: 'Glaucoma', label: 'Glaucoma'},
    {value: 'Intraocular Lens', label: 'Intraocular Lens'},
    {value: 'Macular Degeneration', label: 'Macular Degeneration'},
    {value: 'Ocular Pain', label: 'Ocular Pain'},
    {value: 'Visual Disturbance', label: 'Visual Disturbance'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Gynecologic Disorders': [
    {value: 'Abdominal uterine or vaginal bleeding', label: 'Abdominal uterine or vaginal bleeding'},
    {value: 'Contraceptive', label: 'Contraceptive Management'},
    {value: 'Fibroids', label: 'Fibroids'},
    {value: 'Infertility', label: 'Infertility'},
    {value: 'Perimenopause or Menopause', label: 'Perimenopause or Menopause'},
    {value: 'Polycystic Ovary Syndrome (PCOS)', label: 'Polycystic Ovary Syndrome (PCOS)'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Hematologic Disorders': [
    {value: 'Anemia/Iron Deficiency', label: 'Anemia/Iron Deficiency'},
    {value: 'Blood Disorder', label: 'Blood Disorder'},
    {value: 'Disorder of white blood cells', label: 'Disorder of white blood cells'},
    {value: 'Enlarged lymph nodes', label: 'Enlarged lymph nodes'},
    {value: 'Immunodeficiency', label: 'Immunodeficiency'},
    {value: 'Lymphedema', label: 'Lymphedema'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Infectious Diseases': [
    {value: 'Bacterial or Viral infection', label: 'Bacterial or Viral Infection'},
    {value: 'Coronavirus (COVI-19)', label: 'Coronavirus (COVID-19)'},
    {value: 'Fever', label: 'Fever'},
    {value: 'Human Immunodeficiency Virus (HIV)', label: 'Human Immunodeficiency Virus (HIV)'},
    {label: 'Immunizations', value: 'Immunizations'},
    {label: 'Lyme Disease', value: 'Lyme Disease'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Mental Health Disorders': [
    {value: 'Adjustment Disorder', label: 'Adjustment Disorder'},
    {value: 'Anxiety Disorder', label: 'Anxiety Disorder'},
    {value: 'Attention-Deficit Hyperactivity Disorder (ADHD)', label: 'Attention-Deficit Hyperactivity Disorder (ADHD)'},
    {value: 'Autistic Disorder', label: 'Autistic Disorder'},
    {value: 'Depression', label: 'Depression'},
    {value: 'Speech and sound disorder', label: 'Speech and sound disorder'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Musculoskeletal Disorders': [
    {value: 'Back Pain', label: 'Back Pain'},
    {value: 'Hip Pain', label: 'Hip Pain'},
    {value: 'Knee Pain', label: 'Knee Pain'},
    {value: 'Muscle Weakness', label: 'Muscle Weakness'},
    {value: 'Neck Pain', label: 'Neck Pain'},
    {value: 'Sciatica', label: 'Sciatica'},
    {value: 'Scoliosis', label: 'Scoliosis'},
    {value: 'Shoulder Pain', label: 'Shoulder Pain'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Neurologic Disorders': [
    {value: 'Dizziness', label: 'Dizziness'},
    {value: 'Headache', label: 'Headache/Migraine'},
    {value: 'Insomnia', label: 'Insomnia'},
    {value: 'Multiple Sclerosis', label: 'Multiple Sclerosis'},
    {value: 'Sleep Apnea', label: 'Sleep Apnea'},
    {value: 'Stroke', label: 'Stroke'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Newborn Care': [
    {value: 'Birth - Single', label: 'Birth - Single'},
    {value: 'Birth - Multiples', label: 'Birth - Multiples'},
    {value: 'Feeding Problems', label: 'Feeding Problems'},
    {value: 'Injury at birth', label: 'Injury at birth'},
    {value: 'Jaundice', label: 'Jaundice'},
    {value: 'Newborn Screening', label: 'Newborn screening'},
    {value: 'Preterm Birth', label: 'Preterm Birth'},
    {value: 'Retinal Screening', label: 'Retinal Screening'},
    {value: 'Reduced Muscle Tone', label: 'Reduced muscle tone at birth'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Obstetric Care': [
    {value: 'Delivery/Birth', label: 'Delivery/Birth'},
    {value: 'Doula Support', label: 'Doula Support'},
    {value: 'Gestational Diabetes', label: 'Gestational Diabetes'},
    {value: 'High Risk Pregnancy', label: 'High Risk Pregnancy'},
    {value: 'Miscarriage', label: 'Miscarriage'},
    {value: 'Pre-delivery care', label: 'Pre-delivery care'},
    {value: 'Post-partum care', label: 'Post-partum care'},
    {value: 'Severe morning sickness and nausea', label: 'Severe morning sickness and nausea'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Oncologic Disorders': [
    {value: 'Breast cancer', label: 'Breast cancer'},
    {value: 'Cervical cancer', label: 'Cervical cancer'},
    {value: 'Colon cancer', label: 'Colon cancer'},
    {value: 'Hodgkin Lymphoma', label: 'Hodgkin Lymphoma'},
    {value: 'Leukemia', label: 'Leukemia'},
    {value: 'Lung cancer', label: 'Lung cancer'},
    {value: 'Non-Hodgkin Lymphoma', label: 'Non-Hodgkin Lymphoma'},
    {value: 'Prostate cancer', label: 'Prostate cancer'},
    {value: 'Skin cancer', label: 'Skin cancer'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Other/Non-specified': [
    {value: 'Delayed milestones in childhood', label: 'Delayed milestones in childhood'},
    {value: 'Delayed Learning', label: 'Delayed Learning'},
    {value: 'Down syndrome', label: 'Down syndrome'},
    {value: 'Dyslexia', label: 'Dyslexia'},
    {value: 'Edema', label: 'Edema'},
    {value: 'Fatigue', label: 'Fatigue'},
    {value: 'Pain', label: 'Pain'},
    {value: 'Seizures', label: 'Seizures'},
    {value: 'Stress', label: 'Stress'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  Preventive: [
    {value: 'Annual exam', label: 'Annual exam'},
    {value: 'Bone Density Screening', label: 'Bone Density Screening'},
    {value: 'Breast Cancer Screening', label: 'Breast Cancer Screening'},
    {value: 'Cervical Cancer Screening', label: 'Cervical Cancer Screening'},
    {value: 'Colon Cancer Screening', label: 'Colon Cancer Screening'},
    {value: 'Dietary and nutritional counseling', label: 'Dietary and nutritional counseling'},
    {value: 'Depressesion Screening', label: 'Depression Screening'},
    {value: 'Echo cardiogram (EKG)', label: 'Echo cardiogram (EKG)'},
    {value: 'Immunizations and vaccines', label: 'Immunizations and vaccines'},
    {value: 'Prostate Cancer Screening (PSA)', label: 'Prostate Cancer Screening (PSA)'},
    {value: 'STD Screening', label: 'STD Screening'},
    {value: 'Tuberculosis (TB) Testing', label: 'Tuberculosis (TB) Testing'},
    {value: 'Well woman exam', label: 'Well woman exam'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Renal Disorders': [
    {value: 'Bacterial Infection', label: 'Bacterial Infection'},
    {value: 'Cyst of Kidney', label: 'Cyst of Kidney'},
    {value: 'Kidney Disease', label: 'Kidney Disease'},
    {value: 'Kidney Failure', label: 'Kidney Failure'},
    {value: 'Kidney Transplant', label: 'Kidney Transplant'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Respiratory Disorders': [
    {value: 'Asthma', label: 'Asthma'},
    {value: 'Bronchitis', label: 'Bronchitis'},
    {value: 'Chronic Obstructive Pulmonary Disease (COPD)', label: 'Chronic Obstructive Pulmonary Disease (COPD)'},
    {value: 'Cough', label: 'Cough'},
    {value: 'Influenza/Flu', label: 'Influenza/Flu'},
    {value: 'Pneumonia', label: 'Pneumonia'},
    {value: 'Shortness of Breath', label: 'Shortness of Breath'},
    {value: 'Wheezing', label: 'Wheezing'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Rheumatologic Disorders': [
    {value: 'Arthritis', label: 'Arthritis'},
    {value: 'Gout', label: 'Gout'},
    {value: 'Lupus', label: 'Lupus'},
    {value: 'Sjogren Syndrome', label: 'Sjogren Syndrome'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Skin Disorders': [
    {value: 'Acne', label: 'Acne'},
    {value: 'Dermantitis - eczema, rash or skin irritation', label: 'Dermatitis - eczema, rash or skin irritation'},
    {value: 'Psoriasis', label: 'Psoriasis'},
    {value: 'Skin cancer', label: 'Skin cancer'},
    {value: 'Sun exposure damage', label: 'Sun exposure damage'},
    {value: 'Suspicious mole(s)', label: 'Suspicious mole(s)'},
    {value: 'Warts', label: 'Warts'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Urologic Disorders': [
    {value: 'Benign Prostatic Hyperplasia (BPH)', label: 'Benign Prostatic Hyperplasia (BPH)'},
    {value: 'Kidney Stones', label: 'Kidney Stones'},
    {value: 'Overactive Bladder', label: 'Overactive Bladder'},
    {value: 'Pain or discomfort when urinating', label: 'Pain or discomfort when urinating'},
    {value: 'Prostate Disorders', label: 'Prostate Disorders'},
    {value: 'Urinary Incontinence', label: 'Urinary Incontinence'},
    {value: 'Urinary Tract Infection (UTI)', label: 'Urinary Tract Infection (UTI)'},
    {value: 'Other', label: 'Other - Please Specify'}
  ],
  'Vascular Disorders': [
    {value: 'Artery Disease', label: 'Artery Disease'},
    {value: 'Circulatory system disorder', label: 'Circulatory system disorder'},
    {value: 'Embolism and thrombosis', label: 'Embolism and thrombosis'},
    {value: 'Enlarded, swollen veins', label: 'Enlarded, swollen veins'},
    {value: 'Inflammation of the artery walls', label: 'Inflammation of the artery walls'},
    {value: 'Varicose veins', label: 'Varicose veins'},
    {value: 'Vascular disease', label: 'Vascular disease'},
    {value: 'Venous insufficiency', label: 'Venous insufficiency'},
    {value: 'Other', label: 'Other - Please Specify'}
  ]
}

export default function ClaimForm() {
  // Define a few variables
  const dispatch = useDispatch()
  const location = useLocation()
  const aetnasso = useSelector((state) => state.member.AETNA)
  const [requestAetnaSSO, setrequestAetnaSSO] = useState(false)
  const [useLastClaimSubmitted, setUseLastClaimSubmitted] = useState(false)
  const claimType = location && location.state && location.state.claimType ? location.state.claimType : 'cnq'
  const [formTypeID, setFormTypeID] = useState(1)

  // Need to load dependents as they are part of a drop down in the claim process
  useEffect(() => {
    dispatch(Member.actions.fetchDependents())
  }, [dispatch])
  // Need to load HBO as they are part of a drop down in the claim process
  useEffect(() => {
    dispatch(Member.actions.fetchHBO())
  }, [dispatch])
  // Need to load Other Insurance details (if they exist)
  useEffect(() => {
    dispatch(Member.actions.fetchOtherInsurance())
  }, [dispatch])
  // Need to load Countries
  useEffect(() => {
    dispatch(Member.actions.fetchCountries())
  }, [dispatch])
  // Need to load Previous Service Country
  useEffect(() => {
    dispatch(Member.actions.fetchPreviousServiceCountry())
  }, [dispatch])
  // Load Previous Claim Data as it may be required and dont want to wait for it to load
  useEffect(() => {
    dispatch(Member.actions.fetchPreviousClaimData(formTypeID && formTypeID ? formTypeID : 1))
  }, [dispatch, formTypeID])
  // Load current country of residence
  useEffect(() => {
    dispatch(Member.actions.fetchCountryOfResidence())
  }, [dispatch])
  useEffect(() => {
    if (!aetnasso && !requestAetnaSSO) {
      dispatch(Member.actions.fetchAETNA())
      setrequestAetnaSSO(true)
    }
  }, [dispatch, aetnasso, requestAetnaSSO])

  // Map Dependents and Auth to Redux State
  const Dependents = useSelector((state) => state.member.Dependents)
  const countryOfResidence = useSelector((state) => state.member.CountryOfResidence)
  const corWarning = useSelector((state) => state.member.corWarning)
  const previousServiceCountry = useSelector((state) => state.member.PreviousServiceCountry)
  const otherInsurance = useSelector((state) => state.member.OtherInsurance)
  const returnStatus = useSelector((state) => state.member.ReturnStatus)
  const countries = useSelector((state) => state.member.Countries)
  const authState = useSelector((state) => state.auth)
  const hbo = useSelector((state) => state.member.HBO)
  const lastClaimSubmitted = useSelector((state) => state.member.PreviousClaimData)
  const [showWarning, setShowWarning] = useState(true)

  // Set form type default
  const [formType, setFormType] = useState(claimType && claimType === 'mtc' ? 'MassageTherapyClaim' : 'ClaimsNoQuestions')
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  function allowMoreEditing() {
    // Close Submitting Modal
    setOpen(false)
    // Reactivate submit for another attempt
    setIsLoading(false)
  }

  function Savesubmit(data) {
    // Open Submitting modal
    setOpen(true)
    setIsLoading(true)
    // Add formtype to form post
    data['FormType'] = formType
    // Create structure to load file
    const formData = new FormData()
    // Add fields
    formData.append('Comments', data['CommentEntry'])
    formData.append('Declaration', data['Declaration'])
    formData.append('FormType', data['FormType'])
    formData.append('HBO', data['HBO'])
    formData.append('PersonClaim', data['PersonClaim'])
    formData.append('ReasonEntry', data['ReasonEntry'])
    formData.append('ReasonEntryOther', data['ReasonEntryOther'])
    formData.append('ReasonAdditionalEntry', data['ReasonAdditionalEntry'])
    formData.append('ReasonAdditionalEntryOther', data['ReasonAdditionalEntryOther'])
    formData.append('TrackingInformation', data['TrackingInformation'])
    formData.append('ServiceYear', data['ServiceYear'])
    formData.append('ServiceCountry', data['ServiceCountry'])
    formData.append('ServiceCountryName', countries.find((v) => v.id === data['ServiceCountry']).country)
    formData.append('fsbpId', data['FsbpId'])
    formData.append('OtherInsurance', data['otherInsurance'])
    // Massage Therapy Claim fields
    formData.append('MassageTherapyProvider', data['MassageTherapyProvider'])
    formData.append('MassageTherapyProviderAddress', data['MassageTherapyProviderAddress'])
    formData.append('MassageTherapyProviderLicense', data['MassageTherapyProviderLicense'])
    formData.append('MassageTherapyProofOfPaymentCashSelector', data['ProofOfPaymentCashSelector'])
    // Send Other Insurance Guid regardless if other insurnance is set or not - may be needed to clear it
    formData.append('OtherInsuranceGuid', data['otherInsuranceGuid'])
    // Check if other insurance relevant
    if (data['otherInsurance'] === '1') {
      formData.append('OtherInsurancePersonIssued', data['personIssued'])
      formData.append('OtherInsuranceDependentsNames', data['dependentsNames'])
      formData.append('OtherInsuranceCompanyName', data['companyName'])
      formData.append('OtherInsurancePolicyEffectiveDate', data['policyEffectiveDate'])
      formData.append('OtherInsuranceCompanyClaimsAddress', data['companyClaimsAddress'])
      formData.append('OtherInsuranceActiveEmploymentFlag', data['activeEmploymentFlag'])
      formData.append('OtherInsuranceEmploymentEffectiveDate', data['employmentEffectiveDate'])
      formData.append('OtherInsurancePolicyNumber', data['policyNumber'])
      formData.append('OtherInsurancePolicyCoverageType', data['policyCoverageType'])
      formData.append('OtherInsurancePolicyContractType', data['policyContractType'])
    }
    // Add files
    for (const fileUploadItem of data['PersonFiles']) {
      formData.append('files', fileUploadItem)
    }
    // Add Massage Therapy Proof of Payment
    if (data['MassageTherapyProofOfPaymentFile']) {
      for (const fileUploadItem of data['MassageTherapyProofOfPaymentFile']) {
        formData.append('files', fileUploadItem)
      }
    }

    // Some debugging
    if (process.env.REACT_APP_DEBUG) {
      console.log(data)
    }
    // Save request/form
    dispatch(Member.actions.putClaimData({formData}))
  }

  function SetFormType() {
    const {values} = useFormikContext()
    //
    // Add form type to formik so it an be used in Yup.
    //
    switch (formType) {
      case 'ClaimsNoQuestions':
        values['FormType'] = 'ClaimsNoQuestions'
        setFormTypeID(1)
        break
      case 'ClaimsWithQuestions':
        values['FormType'] = 'ClaimsWithQuestions'
        setFormTypeID(2)
        break
      case 'ClaimsHBO':
        values['FormType'] = 'ClaimsHBO'
        setFormTypeID(3)
        break
      case 'ClaimsCOVID':
        values['FormType'] = 'ClaimsCOVID'
        setFormTypeID(5)
        break
      case 'MassageTherapyClaim':
        values['FormType'] = 'MassageTherapyClaim'
        setFormTypeID(4)
        break
      default:
    }
    return null
  }

  function FormFiles() {
    const {setFieldValue, errors, values} = useFormikContext()
    const [myFiles, setMyFiles] = useState([])
    const [fileRejections, setFileRejections] = useState([])

    // If form is submitted and fails - re populate the files back into the dropzone
    if (values.PersonFiles && values.PersonFiles.length > 0 && myFiles && myFiles.length === 0) {
      setMyFiles(values.PersonFiles)
    }
    //
    // This question appears for all claim form types
    //
    const fieldName = 'PersonFiles'
    //

    const onDrop = useCallback(
      (acceptedFiles, rejectedFiles) => {
        // Remove any commas in file names
        const sanitizedFiles = acceptedFiles.map((file) => {
          if (file.name.includes(',')) {
            const newName = file.name.replace(/,/g, ' ')
            return new File([file], newName, {type: file.type})
          }
          return file
        })
        setMyFiles((prevFiles) => [...prevFiles, ...sanitizedFiles])
        setFileRejections((prevRejectedFiles) => [...prevRejectedFiles, ...rejectedFiles])
        // Advise log of rejected files
        if (rejectedFiles && rejectedFiles.length > 0) {
          rejectedFiles.forEach((file) => {
            dispatch(Member.actions.putAPILog({message: 'File Rejected (Claim)', file: file.file.name, error: file.errors[0].code, size: (file.file.size / Math.pow(1024, 2)).toFixed(2) * 1}))
          })
        }
        // Setting state is taking too long thus the setFieldValue is not getting the latest value thus using a var to ensure it is correct
        var currentFiles = [...myFiles, ...sanitizedFiles]
        setFieldValue(fieldName, currentFiles)
      },
      [setMyFiles, myFiles, setFileRejections, setFieldValue, fieldName]
    )

    const {getRootProps, getInputProps} = useDropzone({
      accept: {
        'image/jpeg': [],
        'image/png': [],
        'image/jpg': [],
        'image/heic': [],
        'application/pdf': []
      },
      multiple: true,
      maxFiles: 20,
      maxSize: 15728640,
      onDrop
    })

    const removeFile = (file) => () => {
      const newFiles = [...myFiles]
      newFiles.splice(newFiles.indexOf(file), 1)
      setMyFiles(newFiles)
      setFieldValue(fieldName, [...newFiles])
    }

    const files = myFiles.map((file) => (
      <li key={file.name} style={{padding: '5px'}}>
        {file.name} - {(file.size / Math.pow(1024, 2)).toFixed(2) * 1} MB{' '}
        <button style={{marginLeft: 10}} onClick={removeFile(file)}>
          Remove File
        </button>
      </li>
    ))

    const fileRejectionItems = fileRejections.map(({file, errors}) => (
      <li key={file.name}>
        {file.name} - {(file.size / Math.pow(1024, 2)).toFixed(2) * 1} MB
        <ul>
          {errors.map((e) => (
            <>{e.code && e.code === 'file-too-large' ? <li key={e.code}>File too large - Maximum size is 15 MB</li> : <li key={e.code}>{e.message}</li>}</>
          ))}
        </ul>
      </li>
    ))

    return (
      <Grid item xs={12} md={12}>
        <section className='container px-0 mt-10 mb-5'>
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <FileUploadIcon color={'primary'} className={'mt-3 mb-3'} sx={{fontSize: 40}} />
            {formType !== 'MassageTherapyClaim' ? (
              <p className='claim-text'>Use camera to capture documents or upload from device</p>
            ) : (
              <>
                <p className='claim-text'>Upload Itemized Bills for each service </p>
                <p className='claim-text'>For Itemized bill - ex. itemized bill from the provider showing the patient’s name, service provided, service date, and cost for each service.</p>
              </>
            )}
            <p className='claim-text'>(Maximum size 15 MB per file)</p>
          </div>
          {files.length > 0 && (
            <aside>
              <h4 style={{marginTop: 10}}>Files</h4>
              <ul>{files}</ul>
            </aside>
          )}
          {fileRejectionItems.length > 0 && (
            <aside>
              <h4 style={{marginTop: 10}}>File Errors</h4>
              <ul>{fileRejectionItems}</ul>
            </aside>
          )}
        </section>

        {errors[fieldName] ? <p className='error-help'>{errors[fieldName]}</p> : ''}
      </Grid>
    )
  }

  function FormMassageTherapyProofOfPaymentCashSelector() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types
    //
    const fieldName = 'ProofOfPaymentCashSelector'
    //
    return (
      <>
        <Grid item xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            Was Cash Paid for this claim
          </FormLabel>
        </Grid>
        <Grid item xs={3} md={3}>
          <Select aria-label='Was Cash Paid for this claim' id='ProofOfPaymentCashSelector' name={fieldName} value={values[fieldName]} onChange={handleChange(fieldName)} className='w-100'>
            <MenuItem key='NO' value='NO'>
              No
            </MenuItem>
            <MenuItem key='YES' value='YES'>
              Yes
            </MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} md={12}>
          {touched[fieldName] && !!errors[fieldName] ? <p className='error-help'>{errors[fieldName]}</p> : ''}
        </Grid>
      </>
    )
  }

  function FormMassageTherapyProofOfPayment() {
    // Need to capture the Massage Therapy Claim Proof of Payment separately
    const {setFieldValue, errors, values} = useFormikContext()
    const [myFiles, setMyFiles] = useState([])
    const [fileRejections, setFileRejections] = useState([])
    //
    // If form is submitted and fails - re populate the files back into the dropzone
    if (values.MassageTherapyProofOfPaymentFile && values.MassageTherapyProofOfPaymentFile.length > 0 && myFiles && myFiles.length === 0) {
      setMyFiles(values.MassageTherapyProofOfPaymentFile)
    }
    //
    // This question appears for all claim form types
    //
    const fieldName = 'MassageTherapyProofOfPaymentFile'
    //

    const onDrop = useCallback(
      (acceptedFiles, rejectedFiles) => {
        // Remove any commas in file names
        const sanitizedFiles = acceptedFiles.map((file) => {
          if (file.name.includes(',')) {
            const newName = file.name.replace(/,/g, ' ')
            return new File([file], newName, {type: file.type})
          }
          return file
        })
        setMyFiles((prevFiles) => [...prevFiles, ...sanitizedFiles])
        setFileRejections((prevRejectedFiles) => [...prevRejectedFiles, ...rejectedFiles])
        // Advise log of rejected files
        if (rejectedFiles && rejectedFiles.length > 0) {
          rejectedFiles.forEach((file) => {
            dispatch(Member.actions.putAPILog({message: 'File Rejected (Claim)', file: file.file.name, error: file.errors[0].code, size: (file.file.size / Math.pow(1024, 2)).toFixed(2) * 1}))
          })
        }
        // Setting state is taking too long thus the setFieldValue is not getting the latest value thus using a var to ensure it is correct
        var currentFiles = [...myFiles, ...sanitizedFiles]
        setFieldValue(fieldName, currentFiles)
      },
      [setMyFiles, myFiles, setFileRejections, setFieldValue, fieldName]
    )

    const {getRootProps, getInputProps} = useDropzone({
      accept: {
        'image/jpeg': [],
        'image/png': [],
        'image/jpg': [],
        'image/heic': [],
        'application/pdf': []
      },
      multiple: true,
      maxFiles: 20,
      maxSize: 15728640,
      onDrop
    })

    const removeFile = (file) => () => {
      const newFiles = [...myFiles]
      newFiles.splice(newFiles.indexOf(file), 1)
      setMyFiles(newFiles)
      setFieldValue(fieldName, [...newFiles])
    }

    const files = myFiles.map((file) => (
      <li key={file.name} style={{padding: '5px'}}>
        {file.name} - {(file.size / Math.pow(1024, 2)).toFixed(2) * 1} MB{' '}
        <button style={{marginLeft: 10}} onClick={removeFile(file)}>
          Remove File
        </button>
      </li>
    ))

    const fileRejectionItems = fileRejections.map(({file, errors}) => (
      <li key={file.name}>
        {file.name} - {(file.size / Math.pow(1024, 2)).toFixed(2) * 1} MB
        <ul>
          {errors.map((e) => (
            <>{e.code && e.code === 'file-too-large' ? <li key={e.code}>File too large - Maximum size is 15 MB</li> : <li key={e.code}>{e.message}</li>}</>
          ))}
        </ul>
      </li>
    ))

    return (
      <>
        <FormLabel className='gray-1-text mt-10' htmlFor={fieldName}>
          All Massage Therapy Claims require proof of payment. Please upload your proof of payment below
        </FormLabel>
        <Grid item xs={12} md={12}>
          <section className='container px-0 mb-5'>
            <div {...getRootProps({className: 'dropzone'})}>
              <input {...getInputProps()} />
              <FileUploadIcon color={'primary'} className={'mt-3 mb-3'} sx={{fontSize: 40}} />
              <p className='claim-text'>For Proof of payment, e.g., provider proof of payment stamp, cash register receipt, credit card receipt, canceled check, etc. </p>
              <p className='claim-text'>(Maximum size 15 MB per file)</p>
            </div>
            {files.length > 0 && (
              <aside>
                <h4 style={{marginTop: 10}}>Files</h4>
                <ul>{files}</ul>
              </aside>
            )}
            {fileRejectionItems.length > 0 && (
              <aside>
                <h4 style={{marginTop: 10}}>File Errors</h4>
                <ul>{fileRejectionItems}</ul>
              </aside>
            )}
          </section>

          {errors[fieldName] ? <p className='error-help'>{errors[fieldName]}</p> : ''}
        </Grid>
      </>
    )
  }

  function FormPersonSelector() {
    const {handleChange, values} = useFormikContext()
    //
    // This question appears for all claim form types
    //
    const fieldName = 'PersonClaim'
    //
    //
    // Determine list of people (FSBP member plus dependents)
    var people = []
    // Add member to array
    var member = {
      Name: authState.firstName + ' ' + authState.lastName,
      key: 'P' + authState.member_key
    }
    people.push(member)
    // Check if there are dependents
    if (Dependents) {
      // Add dependents to array together with member
      Dependents.forEach((dependents) => {
        var person = {
          Name: dependents.Name,
          key: 'D' + dependents.key
        }
        people.push(person)
      })
    }
    //
    return (
      <Grid item xs={12} md={6}>
        <FormControl variant='outlined' margin='dense' style={{margin: '14px 0 6px 0', minWidth: '100%'}}>
          <FormLabel className='gray-1-text' id='claimforperson-label'>
            This claim is for...
          </FormLabel>
          <Select aria-label='Claim for Person' id='claimforperson' labelId='claimforperson-label' name={fieldName} value={values[fieldName] || ''} onChange={handleChange(fieldName)}>
            {people
              ? people.map((People) => {
                  return (
                    <MenuItem key={People.key} value={People.key}>
                      {People.Name}
                    </MenuItem>
                  )
                })
              : 'None'}
          </Select>
        </FormControl>
      </Grid>
    )
  }

  function FormServiceCountrySelector() {
    const {setFieldValue, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types
    //
    const fieldName = 'ServiceCountry'
    //
    return (
      <Grid item xs={12} md={6}>
        <FormControl variant='outlined' margin='dense' style={{margin: '14px 0 6px 0', minWidth: '100%'}}>
          <FormLabel className='gray-1-text' id='servicecountry'>
            {formType !== 'MassageTherapyClaim' ? 'Country where service was performed' : 'Country where services were performed or provided'}
          </FormLabel>
          <Autocomplete
            id='servicecountry'
            disableClearable
            options={countries}
            autoHighlight
            value={countries.find((v) => v.id === values[fieldName]) || null}
            onChange={(e, value) => {
              setFieldValue(fieldName, value.id)
            }}
            getOptionLabel={(option) => option.country}
            renderInput={(params) => (
              <TextField
                {...params}
                type='text'
                variant='outlined'
                margin='dense'
                name={fieldName}
                style={{minWidth: '100%'}}
                className={'mt-0'}
                helperText={touched[fieldName] ? errors[fieldName] : ''}
                error={touched[fieldName] && Boolean(errors[fieldName])}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'new-password'
                }}
              />
            )}
          />
        </FormControl>
      </Grid>
    )
  }

  function FormFSBPId() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    if (authState.fsbpId) {
      return null
    }
    //
    const fieldName = 'FsbpId'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Please enter your FSBP Member ID for AETNA Identification
        </FormLabel>
        <Grid item xs={12} md={6}>
          <TextField
            style={{minWidth: '100%'}}
            type='text'
            variant='outlined'
            margin='normal'
            name={fieldName}
            className={'mt-0 mb-0'}
            value={values[fieldName]}
            autoComplete='new-password'
            onChange={handleChange(fieldName)}
            InputProps={{classes: {input: 'input-profile'}}}
            helperText={touched[fieldName] ? errors[fieldName] : ''}
            error={touched[fieldName] && Boolean(errors[fieldName])}
          />
        </Grid>
      </Grid>
    )
  }

  // function FormMassageTherapyProviderInformation() {
  //   //
  //   // This is not a question - just some additional information for Massage Therapy Claims
  //   //
  //   // Check if this question is on form type
  //   if (formType !== 'MassageTherapyClaim') {
  //     return null
  //   }
  //   //
  //   return (
  //     <>
  //       <Alert severity='info' className='claim-text mt-5 mb-5'>
  //         For Massage Therapy Claims please enter the following information.{' '}
  //       </Alert>
  //     </>
  //   )
  // }

  function FormMassageTherapyProviderEntry() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // Check if this question is on form type
    if (formType !== 'MassageTherapyClaim') {
      return null
    }
    //
    const fieldName = 'MassageTherapyProvider'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Name of Massage provider (e.g., first and last name)
        </FormLabel>
        <Grid item xs={12} md={6}>
          <TextField
            id={fieldName}
            className={'mt-0 mb-0'}
            style={{minWidth: '100%'}}
            type='text'
            variant='outlined'
            label=''
            margin='normal'
            name={fieldName}
            value={values[fieldName]}
            autoComplete='new-password'
            onChange={handleChange(fieldName)}
            InputProps={{classes: {input: 'input-profile'}}}
            helperText={touched[fieldName] ? errors[fieldName] : ''}
            error={touched[fieldName] && Boolean(errors[fieldName])}
          />
        </Grid>
      </Grid>
    )
  }

  function FormMassageTherapyProviderAddress() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // Check if this question is on form type
    if (formType !== 'MassageTherapyClaim') {
      return null
    }
    //
    //
    const fieldName = 'MassageTherapyProviderAddress'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Please enter the Address of the Massage Provider
        </FormLabel>
        <TextField
          style={{minWidth: '100%'}}
          className={'mt-0 mb-0'}
          type='text'
          variant='outlined'
          margin='normal'
          name={fieldName}
          value={values[fieldName]}
          autoComplete='new-password'
          onChange={handleChange(fieldName)}
          InputProps={{classes: {input: 'input-profile'}}}
          helperText={touched[fieldName] ? errors[fieldName] : ''}
          error={touched[fieldName] && Boolean(errors[fieldName])}
        />
      </Grid>
    )
  }

  function FormMassageTherapyProviderLicenseEntry() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // Check if this question is on form type
    if (formType !== 'MassageTherapyClaim') {
      return null
    }
    //
    // This question appears if the service country is in the US - check for this
    if (values.ServiceCountry !== '961bcddc-575e-4139-9907-6b4a5f6758b0') {
      return null
    }
    //
    const fieldName = 'MassageTherapyProviderLicense'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Please enter the provider’s license number (enter n/a or not applicable if your state does not require a license)
        </FormLabel>
        <Grid item xs={12} md={6}>
          <TextField
            style={{minWidth: '100%'}}
            className={'mt-0 mb-0'}
            type='text'
            variant='outlined'
            margin='normal'
            name={fieldName}
            value={values[fieldName]}
            autoComplete='new-password'
            onChange={handleChange(fieldName)}
            InputProps={{classes: {input: 'input-profile'}}}
            helperText={touched[fieldName] ? errors[fieldName] : ''}
            error={touched[fieldName] && Boolean(errors[fieldName])}
          />
        </Grid>
      </Grid>
    )
  }

  function FormReasonEntry() {
    const {handleChange, setFieldValue, handleBlur, values, touched, errors, submitCount} = useFormikContext()
    //
    // Check if this question is on form type

    //
    const fieldName = 'ReasonEntry'
    const otherFieldName = 'ReasonEntryOther'

    let labelDescriptor = ''
    let extraInformation = ''
    //
    // Set label based on formType
    if (formType === 'ClaimsCOVID') {
      extraInformation = 'Please submit a detailed receipt with the date of purchase, the store or supplier from which you made the purchase, the test type, and the number of tests you purchased.'
      labelDescriptor = 'Enter Purchase Information and upload the receipt'
    } else {
      if (formType === 'MassageTherapyClaim') {
        labelDescriptor =
          'We will translate your claims. However, it is helpful if you include a brief description of the services provided whether on the coversheet, written directly on your claim form, bill or a separate sheet of paper.'
      } else {
        labelDescriptor = 'Diagnosis'
      }
    }
    //
    return (
      <Grid item xs={12}>
        <FormControl variant='outlined' margin='dense' style={{margin: '14px 0 6px 0', minWidth: '100%'}}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            {labelDescriptor}
          </FormLabel>
          <label style={{fontWeight: 'bold'}}>{extraInformation}</label>
          {formType === 'MassageTherapyClaim' || formType === 'ClaimsCOVID' ? (
            <TextField
              style={{minWidth: '100%'}}
              className={'mt-0'}
              id={fieldName}
              type='text'
              variant='outlined'
              margin='normal'
              name={fieldName}
              value={values[fieldName] || ''}
              autoComplete='new-password'
              helperText={touched[fieldName] ? errors[fieldName] : ''}
              error={touched[fieldName] && Boolean(errors[fieldName])}
              multiline
              minRows={4}
              onChange={handleChange(fieldName)}
              InputProps={{classes: {input: 'input-profile'}}}
            />
          ) : (
            <>
              <Grid container spacing={2} alignItems='flex-start'>
                {/* Select */}
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth error={touched[fieldName] && Boolean(errors[fieldName])}>
                    <Select
                      id={fieldName}
                      name={fieldName}
                      value={values[fieldName] || ''}
                      onChange={(e) => {
                        handleChange(e)
                        if (e.target.value !== 'Other') {
                          setFieldValue(otherFieldName, '')
                        }
                      }}
                      displayEmpty
                    >
                      <MenuItem value=''>
                        <em>Please select diagnosis</em>
                      </MenuItem>
                      <MenuItem value='Accident/Injury'>Accident/Injury</MenuItem>
                      <MenuItem value='Allergy Disorders'>Allergy Disorders</MenuItem>
                      <MenuItem value='Cardiac Disorders'>Cardiac Disorders</MenuItem>
                      <MenuItem value='Digestive Disorders'>Digestive Disorders</MenuItem>
                      <MenuItem value='Ear/Nose/Throat Disorders'>Ear/Nose/Throat Disorders</MenuItem>
                      <MenuItem value='Endocrine Disorders'>Endocrine Disorders</MenuItem>
                      <MenuItem value='Eye Disorders'>Eye Disorders</MenuItem>
                      <MenuItem value='Gynecologic Disorders'>Gynecologic Disorders</MenuItem>
                      <MenuItem value='Hematologic Disorders'>Hematologic Disorders</MenuItem>
                      <MenuItem value='Infectious Diseases'>Infectious Diseases</MenuItem>
                      <MenuItem value='Mental Health Disorders'>Mental Health Disorders</MenuItem>
                      <MenuItem value='Musculoskeletal Disorders'>Musculoskeletal Disorders</MenuItem>
                      <MenuItem value='Neurologic Disorders'>Neurologic Disorders</MenuItem>
                      <MenuItem value='Newborn Care'>Newborn Care</MenuItem>
                      <MenuItem value='Obstetric Care'>Obstetric Care</MenuItem>
                      <MenuItem value='Oncologic Disorders'>Oncologic Disorders</MenuItem>
                      <MenuItem value='Other/Non-specified'>Other/Non-Specified</MenuItem>
                      <MenuItem value='Preventive'>Preventive</MenuItem>
                      <MenuItem value='Renal Disorders'>Renal Disorders</MenuItem>
                      <MenuItem value='Respiratory Disorders'>Respiratory Disorders</MenuItem>
                      <MenuItem value='Rheumatologic Disorders'>Rheumatologic Disorders</MenuItem>
                      <MenuItem value='Skin Disorders'>Skin Disorders</MenuItem>
                      <MenuItem value='Urologic Disorders'>Urologic Disorders</MenuItem>
                      <MenuItem value='Vascular Disorders'>Vascular Disorders</MenuItem>
                    </Select>

                    {touched[fieldName] && errors[fieldName] && <FormHelperText>{errors[fieldName]}</FormHelperText>}
                  </FormControl>
                </Grid>

                {/* Other */}
                {values[fieldName] === 'Other' && (
                  <Grid item xs={12} md={8}>
                    <TextField
                      id={otherFieldName}
                      name={otherFieldName}
                      label='Please specify'
                      variant='outlined'
                      fullWidth
                      multiline
                      minRows={3}
                      value={values[otherFieldName]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={(touched[otherFieldName] || submitCount > 0) && Boolean(errors[otherFieldName])}
                      helperText={touched[otherFieldName] || submitCount > 0 ? errors[otherFieldName] : ''}
                    />
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </FormControl>
      </Grid>
    )
  }

  function FormReasonAdditionalEntry() {
    const {handleChange, setFieldValue, handleBlur, values, touched, errors, submitCount} = useFormikContext()

    const fieldName = 'ReasonAdditionalEntry'
    const otherFieldName = 'ReasonAdditionalEntryOther'

    // Excluded form types
    if (formType === 'ClaimsCOVID' || formType === 'MassageTherapyClaim') {
      return null
    }

    const additionalOptions = diagnosisAdditionalOptions?.[values.ReasonEntry] ?? []

    return (
      <Grid item xs={12}>
        <FormControl variant='outlined' margin='dense' style={{margin: '14px 0 6px 0', minWidth: '100%'}}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            Diagnosis Specific
          </FormLabel>
          <Grid container spacing={2} alignItems='flex-start'>
            {/* Select */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth error={touched[fieldName] && Boolean(errors[fieldName])}>
                <Select
                  id={fieldName}
                  name={fieldName}
                  value={values[fieldName]}
                  onChange={(e) => {
                    handleChange(e)

                    if (e.target.value !== 'Other') {
                      setFieldValue(otherFieldName, '')
                    }
                  }}
                  displayEmpty
                >
                  <MenuItem value=''>
                    <em>Please select diagnosis subcategory</em>
                  </MenuItem>
                  {additionalOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>

                {touched[fieldName] && errors[fieldName] && <FormHelperText>{errors[fieldName]}</FormHelperText>}
              </FormControl>
            </Grid>
            {/* Other */}
            {values[fieldName] === 'Other' && (
              <Grid item xs={12} md={8}>
                <TextField
                  id={otherFieldName}
                  name={otherFieldName}
                  label='Please specify'
                  variant='outlined'
                  fullWidth
                  multiline
                  minRows={3}
                  value={values[otherFieldName]}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={(touched[otherFieldName] || submitCount > 0) && Boolean(errors[otherFieldName])}
                  helperText={touched[otherFieldName] || submitCount > 0 ? errors[otherFieldName] : ''}
                />
              </Grid>
            )}
          </Grid>
        </FormControl>
      </Grid>
    )
  }

  function FormTrackingInformation() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types
    //
    const fieldName = 'TrackingInformation'
    //
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <label>(Optional) Please enter Service Dates and/or any other identifiable information for your own personal tracking purposes.</label>
        <TextField
          style={{margin: '14px 0 6px 0', minWidth: '100%'}}
          type='text'
          variant='outlined'
          margin='normal'
          name={fieldName}
          value={values[fieldName]}
          autoComplete='new-password'
          size='medium'
          helperText={touched[fieldName] ? errors[fieldName] : ''}
          error={touched[fieldName] && Boolean(errors[fieldName])}
          multiline
          minRows={2}
          onChange={handleChange(fieldName)}
          InputProps={{classes: {input: 'input-profile'}}}
        />
      </Grid>
    )
  }

  function FormHBOSelector() {
    const {handleChange, values} = useFormikContext()
    // Check if this question is on form type
    if (formType !== 'ClaimsHBO') {
      return null
    }
    //
    const fieldName = 'HBO'
    //
    return (
      <Grid item xs={9} md={9}>
        <FormControl variant='outlined' margin='dense' style={{margin: '14px 0 6px 0', minWidth: '100%'}}>
          <InputLabel shrink id='forhbo-label'>
            Please select the Health Benefit Officer
          </InputLabel>
          <Select
            aria-label='Health Benefits Officer'
            id='forhbo'
            labelId='forhbo-label'
            label='Please select the Health Benefit Officer'
            name={fieldName}
            value={values[fieldName] || ''}
            onChange={handleChange(fieldName)}
          >
            {hbo
              ? hbo.map((HBO) => {
                  return (
                    <MenuItem key={HBO.id} value={HBO.id}>
                      {HBO.first_name} {HBO.last_name}.
                    </MenuItem>
                  )
                })
              : 'None'}
          </Select>
        </FormControl>
      </Grid>
    )
  }

  function FormCommentEntry() {
    const {handleChange, values} = useFormikContext()
    // Check if this question is on form type
    if (formType !== 'ClaimsWithQuestions' && formType !== 'ClaimsCOVID' && formType !== 'ClaimsHBO') {
      return null
    }
    //
    const fieldName = 'CommentEntry'
    let labelDescriptor = ''
    //
    if (formType === 'ClaimsCOVID') {
      labelDescriptor = 'Enter who the test(s) were purchased for'
    } else {
      if (formType === 'ClaimsHBO') {
        labelDescriptor = 'Please provide any additional information or questions for the Health Benefits Officer'
      } else {
        labelDescriptor = 'Questions'
      }
    }
    //
    return (
      <Grid item xs={12} md={12}>
        <label>{labelDescriptor}</label>
        <TextField
          style={{margin: '14px 0 6px 0', minWidth: '100%'}}
          type='text'
          variant='outlined'
          margin='normal'
          name={fieldName}
          value={values[fieldName]}
          autoComplete='new-password'
          size='small'
          multiline
          rows={4}
          onChange={handleChange(fieldName)}
          InputProps={{classes: {input: 'input-profile'}}}
        />
      </Grid>
    )
  }

  function FormCommentInformation() {
    //
    // This is not a question - just some additional information for COVID Test Kit claims

    // Check if this question is on form type
    if (formType !== 'ClaimsCOVID') {
      return null
    }
    //
    return (
      <>
        <Grid item xs={12} md={12} style={{paddingTop: 10, fontWeight: 'bold'}}>
          <label>
            Please detail the number of tests purchased for each covered family member in your submission. For example, two tests for Martin, two tests for Brittany, and six tests for Emilio.
          </label>
        </Grid>
      </>
    )
  }

  function FormOtherInsuranceSelector() {
    const {handleChange, values} = useFormikContext()
    //
    // This question appears for all claim form types
    //
    const fieldName = 'otherInsurance'
    //
    return (
      <>
        <Grid className={'mt-3'} item xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={'declaration'}>
            Are you or any member of your family covered under any other health plan other than FOREIGN SERVICE BENEFIT PLAN?
          </FormLabel>
        </Grid>
        <Grid item xs={3} md={3}>
          <Select aria-label='Claim Declaration' id='declaration' className={'w-100'} name={fieldName} value={values[fieldName]} onChange={handleChange(fieldName)}>
            <MenuItem key='NO' value='0'>
              No
            </MenuItem>
            <MenuItem key='YES' value='1'>
              Yes
            </MenuItem>
          </Select>
        </Grid>
      </>
    )
  }

  function FormOtherInsuranceHeading() {
    const {values} = useFormikContext()
    //
    // This is not a question - only a header
    //
    return (
      <>
        <Grid item xs={12} md={12} style={{paddingTop: 20, fontWeight: 'bold'}}>
          <Typography gutterBottom variant='h5' className='font-bold' component='h5'>
            Other Insurance Coverage Information
          </Typography>
          {values.otherInsurance === '1' && (
            <>
              <label style={{fontWeight: 'bold', color: 'red'}}>(Please review your existing information. Select No to remove your existing information)</label>
            </>
          )}
        </Grid>
        <Grid item xs={12} md={12} style={{paddingTop: 5}}>
          <label>
            Other insurance coverage information should be provided at least once per year, or if any changes have been made to your other insurance coverage. (See Section on coordination of benefits
            in your Brochure)
          </label>
        </Grid>
      </>
    )
  }

  function FormOtherInsurancePersonIssued() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'personIssued'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Person in whose name the other plan is issued
        </FormLabel>
        <Grid item xs={6} md={6}>
          <TextField
            id={fieldName}
            style={{minWidth: '100%'}}
            className={'mt-0'}
            type='text'
            variant='outlined'
            margin='normal'
            name={fieldName}
            value={values[fieldName]}
            autoComplete='new-password'
            onChange={handleChange(fieldName)}
            InputProps={{classes: {input: 'input-profile'}}}
            helperText={touched[fieldName] ? errors[fieldName] : ''}
            error={touched[fieldName] && Boolean(errors[fieldName])}
          />
        </Grid>
      </Grid>
    )
  }

  function FormOtherInsuranceDependentsNames() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'dependentsNames'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Name of all dependents covered under the other plan
        </FormLabel>
        <Grid item xs={12} md={12}>
          <TextField
            id={fieldName}
            className={'mt-0 mb-0'}
            style={{minWidth: '100%'}}
            type='text'
            variant='outlined'
            label=''
            margin='normal'
            name={fieldName}
            value={values[fieldName]}
            autoComplete='new-password'
            onChange={handleChange(fieldName)}
            InputProps={{classes: {input: 'input-profile'}}}
            helperText={touched[fieldName] ? errors[fieldName] : ''}
            error={touched[fieldName] && Boolean(errors[fieldName])}
          />
          <FormHelperText>Separate names using commas</FormHelperText>
        </Grid>
      </Grid>
    )
  }

  function FormOtherInsuranceCompanyName() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'companyName'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Name of Insurance Company or Plan
        </FormLabel>
        <TextField
          style={{minWidth: '100%'}}
          className={'mt-0 mb-0'}
          type='text'
          variant='outlined'
          margin='normal'
          name={fieldName}
          value={values[fieldName]}
          autoComplete='new-password'
          onChange={handleChange(fieldName)}
          InputProps={{classes: {input: 'input-profile'}}}
          helperText={touched[fieldName] ? errors[fieldName] : ''}
          error={touched[fieldName] && Boolean(errors[fieldName])}
        />
      </Grid>
    )
  }

  function FormOtherInsuranceCompanyClaimsAddress() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'companyClaimsAddress'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Address of Claims Office
        </FormLabel>
        <TextField
          style={{minWidth: '100%'}}
          className={'mt-0 mb-0'}
          type='text'
          variant='outlined'
          margin='normal'
          name={fieldName}
          value={values[fieldName]}
          autoComplete='new-password'
          onChange={handleChange(fieldName)}
          InputProps={{classes: {input: 'input-profile'}}}
          helperText={touched[fieldName] ? errors[fieldName] : ''}
          error={touched[fieldName] && Boolean(errors[fieldName])}
        />
      </Grid>
    )
  }

  function FormOtherInsurancePolicyEffectiveDate() {
    const {setFieldValue, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'policyEffectiveDate'
    //
    return (
      <>
        <Grid item className={'mt-3'} xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            Policy Effective Date
          </FormLabel>
          <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                id={fieldName}
                name={fieldName}
                className={'w-100'}
                onChange={(value) => setFieldValue(fieldName, value, true)}
                value={values[fieldName] ? dayjs(values[fieldName]) : dayjs()}
                slotProps={{
                  textField: {
                    fullWidth: false,
                    variant: 'outlined',
                    error: !!errors[fieldName],
                    helperText: errors[fieldName]?.message
                  }
                }}
                error={errors[fieldName]}
                touched={touched[fieldName]}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </>
    )
  }

  function FormOtherInsuranceActiveEmploymentFlag() {
    const {handleChange, values} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'activeEmploymentFlag'
    //
    return (
      <>
        <Grid item className={'mt-3'} xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            Is this insurance through active employment?
          </FormLabel>
        </Grid>
        <Grid item xs={6} md={3}>
          <Select
            aria-label='Other Insurance Policy Active Employment Flag'
            id='OtherInsuranceActiveEmploymentFlag'
            name={fieldName}
            value={values[fieldName]}
            className={'w-100'}
            onChange={handleChange(fieldName)}
          >
            <MenuItem key='No' value='0'>
              No
            </MenuItem>
            <MenuItem key='Yes' value='1'>
              Yes
            </MenuItem>
            <MenuItem key='NotSet' value='2'>
              Not Set
            </MenuItem>
          </Select>
        </Grid>
      </>
    )
  }

  function FormOtherInsuranceEmploymentEffectiveDate() {
    const {setFieldValue, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    // Check if Other Insurance is through active employment
    if (values.activeEmploymentFlag !== '1') {
      return null
    }
    //
    const fieldName = 'employmentEffectiveDate'
    //
    return (
      <>
        <Grid item className={'mt-3'} xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            Employment Effective Date
          </FormLabel>
          <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                id={fieldName}
                className={'w-100'}
                name={fieldName}
                onChange={(value) => setFieldValue(fieldName, value, true)}
                value={values[fieldName] ? dayjs(values[fieldName]) : dayjs()}
                slotProps={{
                  textField: {
                    fullWidth: false,
                    variant: 'outlined',
                    error: !!errors[fieldName],
                    helperText: errors[fieldName]?.message
                  }
                }}
                error={errors[fieldName]}
                touched={touched[fieldName]}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </>
    )
  }

  function FormOtherInsurancePolicyNumber() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'policyNumber'
    //
    return (
      <Grid item className={'mt-3'} xs={12} md={12}>
        <FormLabel className='gray-1-text' htmlFor={fieldName}>
          Policy or Contract Number
        </FormLabel>
        <Grid item xs={12} md={6}>
          <TextField
            style={{minWidth: '100%'}}
            type='text'
            variant='outlined'
            margin='normal'
            name={fieldName}
            className={'mt-0 mb-0'}
            value={values[fieldName]}
            autoComplete='new-password'
            onChange={handleChange(fieldName)}
            InputProps={{classes: {input: 'input-profile'}}}
            helperText={touched[fieldName] ? errors[fieldName] : ''}
            error={touched[fieldName] && Boolean(errors[fieldName])}
          />
        </Grid>
      </Grid>
    )
  }

  function FormOtherInsurancePolicyCoverageType() {
    const {handleChange, values} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'policyCoverageType'
    //
    return (
      <>
        <Grid item className={'mt-3'} xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            Plan type
          </FormLabel>
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            aria-label='Other Insurance Policy Coverage Type'
            id='OtherInsurancePolicyCoverageType'
            name={fieldName}
            className={'mt-0 mb-0 w-100'}
            value={values[fieldName]}
            onChange={handleChange(fieldName)}
          >
            <MenuItem key='None' value='None'>
              None
            </MenuItem>
            <MenuItem key='SelfOnlyCoverage' value='SelfOnlyCoverage'>
              Self Only Coverage
            </MenuItem>
            <MenuItem key='Family' value='Family'>
              Family Coverage
            </MenuItem>
          </Select>
        </Grid>
      </>
    )
  }

  function FormOtherInsurancePolicyContractType() {
    const {handleChange, values} = useFormikContext()
    //
    // This question appears for all claim form types however only appears when the OtherInsurance flag is set to 1
    if (values.otherInsurance === '0') {
      return null
    }
    //
    const fieldName = 'policyContractType'
    //
    return (
      <>
        <Grid className={'mt-3'} item xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            Issued under a
          </FormLabel>
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            aria-label='Other Insurance Policy Contract Type'
            id='OtherInsurancePolicyContractType'
            className={'w-100'}
            name={fieldName}
            value={values[fieldName]}
            onChange={handleChange(fieldName)}
          >
            <MenuItem key='None' value='None'>
              None
            </MenuItem>
            <MenuItem key='IndividualContract' value='IndividualContract'>
              Individual
            </MenuItem>
            <MenuItem key='Group' value='Group'>
              Group
            </MenuItem>
          </Select>
        </Grid>
      </>
    )
  }

  function FormDeclarationSelector() {
    const {handleChange, values, touched, errors} = useFormikContext()
    //
    // This question appears for all claim form types
    //
    const fieldName = 'Declaration'
    //
    return (
      <>
        <Grid item xs={12} md={12}>
          <FormLabel className='gray-1-text' htmlFor={fieldName}>
            I certify the information in this claim submission is complete and accurate.
          </FormLabel>
        </Grid>
        <Grid item xs={6} md={3}>
          <Select aria-label='Claim Declaration' id='declaration' name={fieldName} value={values[fieldName]} onChange={handleChange(fieldName)} className='w-100'>
            <MenuItem key='NO' value='0'>
              No
            </MenuItem>
            <MenuItem key='YES' value='1'>
              Yes
            </MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} md={12}>
          {touched[fieldName] && !!errors[fieldName] ? <p className='error-help'>{errors[fieldName]}</p> : ''}
        </Grid>
        <Grid item xs={12} md={12} className={'mt-3'}>
          <label className='font-bold'>
            WARNING: Any intentional false statement in this application or willful misrepresentation is a violation of the law punished by a fine not more than $10,000, or imprisonment of not more
            than five years, or both. (18 U.S.C. 1001).
          </label>
        </Grid>
      </>
    )
  }

  const handleClaimTypeChange = ({target: value}) => {
    // Set form type variable based on selection
    switch (value.value) {
      case 'cnq':
        setFormType('ClaimsNoQuestions')
        break
      case 'cwq':
        setFormType('ClaimsWithQuestions')
        break
      case 'cdh':
        setFormType('ClaimsHBO')
        break
      case 'cov':
        setFormType('ClaimsCOVID')
        break
      case 'mtc':
        setFormType('MassageTherapyClaim')
        break
      default:
    }
  }

  const validationSchema = Yup.object().shape({
    TrackingInformation: Yup.string().max(255, 'Tracking Information is too Long'),
    Declaration: Yup.string().oneOf(['1'], 'Only certified claims can be processed'),
    personIssued: Yup.string().when(['otherInsurance'], {
      is: (otherInsurance) => otherInsurance === '1',
      then: (schema) => schema.required().min(2, 'Too Short').max(100, 'Too Long')
    }),
    dependentsNames: Yup.string().when(['otherInsurance'], {
      is: (otherInsurance) => otherInsurance === '1',
      then: (schema) => schema.required().max(255, 'Too Long')
    }),
    companyName: Yup.string().when(['otherInsurance'], {
      is: (otherInsurance) => otherInsurance === '1',
      then: (schema) => schema.required().min(2, 'Too Short').max(100, 'Too Long')
    }),
    policyNumber: Yup.string().when(['otherInsurance'], {
      is: (otherInsurance) => otherInsurance === '1',
      then: (schema) => schema.required().min(2, 'Too Short').max(20, 'Too Long')
    }),
    companyClaimsAddress: Yup.string().when(['otherInsurance'], {
      is: (otherInsurance) => otherInsurance === '1',
      then: (schema) => schema.required().min(5, 'Too Short').max(255, 'Too Long')
    }),
    policyEffectiveDate: Yup.date().typeError('Policy Effective Date must be a date or left blank').nullable().notRequired(),
    ReasonEntry: Yup.string().when(['FormType'], {
      is: (FormType) => FormType === 'MassageTherapyClaim' || FormType === 'ClaimsCOVID',
      then: (schema) => schema.max(12000, 'Description is too Long'),
      otherwise: (schema) => schema.required('Reason for Visit is required')
    }),
    ReasonEntryOther: Yup.string().test('reason-entry-other', 'Please specify the Other Diagnosis', function (value) {
      const {ReasonEntry, FormType} = this.parent

      if (FormType !== 'MassageTherapyClaim' && FormType !== 'ClaimsCOVID' && ReasonEntry === 'Other') {
        const trimmedValue = value?.trim() || ''

        if (trimmedValue.length < 2) {
          return this.createError({message: 'Please specify the Other Diagnosis'})
        }

        if (trimmedValue.length > 12000) {
          return this.createError({message: 'Diagnosis is too Long'})
        }

        // Ensure at least one non-space character
        if (!/\S/.test(value)) {
          return this.createError({message: 'Please specify the Other Diagnosis'})
        }
      }

      return true
    }),
    ReasonAdditionalEntry: Yup.string().when(['FormType'], {
      is: (FormType) => FormType !== 'MassageTherapyClaim' && FormType !== 'ClaimsCOVID',
      then: (schema) => schema.required('Additional Diagnosis is required'),
      otherwise: (schema) => schema.notRequired()
    }),
    ReasonAdditionalEntryOther: Yup.string().when(['ReasonAdditionalEntry', 'FormType'], {
      is: (ReasonAdditionalEntry, FormType) => FormType !== 'MassageTherapyClaim' && FormType !== 'ClaimsCOVID' && ReasonAdditionalEntry === 'Other',
      then: (schema) =>
        schema
          .min(2, 'Additional Diagnosis is too Short')
          .max(12000, 'Additional Diagnosis is too Long')
          .matches(/\S/, 'Additional Diagnosis must contain non-space characters')
          .required('Please specify the Other Additional Diagnosis'),
      otherwise: (schema) => schema.notRequired()
    }),
    MassageTherapyProvider: Yup.string().when(['FormType'], {
      is: (FormType) => FormType === 'MassageTherapyClaim',
      then: (schema) => schema.min(4, 'Massage Provider Name is Too Short').max(100, 'Massage Provider Name is Too Long').required('Massage Therapy Provider is required')
    }),
    MassageTherapyProviderAddress: Yup.string().when(['FormType'], {
      is: (FormType) => FormType === 'MassageTherapyClaim',
      then: (schema) => schema.min(10, 'Massage Provider Address is Too Short').max(255, 'Massage Provider Address is Too Long').required('Massage Therapy Provider Address is required')
    }),
    MassageTherapyProviderLicense: Yup.string().when(['FormType', 'ServiceCountry'], {
      is: (FormType, ServiceCountry) => FormType === 'MassageTherapyClaim' && ServiceCountry === '961bcddc-575e-4139-9907-6b4a5f6758b0',
      then: (schema) =>
        schema.min(3, 'Massage Provider License Number is Too Short').max(100, 'Massage Provider License Number is Too Long').required('Massage Therapy Provider License Number is required')
    }),
    ServiceCountry: Yup.string().required('Service Country is required'),
    employmentEffectiveDate: Yup.date().typeError('Employment Effective Date must be a date or left blank').nullable().notRequired(),
    PersonFiles: Yup.array().min(1, 'Please upload at least one attachment').required('Please upload at least one attachment'),
    MassageTherapyProofOfPaymentFile: Yup.array().when(['FormType', 'ProofOfPaymentCashSelector'], {
      is: (FormType, ProofOfPaymentCashSelector) => FormType === 'MassageTherapyClaim' && ProofOfPaymentCashSelector === 'NO',
      then: (schema) => schema.min(1, 'Please upload at least one Proof of Payment attachment').required('Please upload at least one Proof of Payment attachment'),
      otherwise: (schema) => schema.notRequired()
    })
  })

  function DisplayQuestions() {
    //
    const {values} = useFormikContext()
    //
    return (
      <React.Fragment>
        <SetFormType />
        <FormHBOSelector />
        <FormPersonSelector />
        <FormServiceCountrySelector />
        <FormFSBPId />
        {/* <FormMassageTherapyProviderInformation /> */}
        <FormMassageTherapyProviderEntry />
        <FormMassageTherapyProviderAddress />
        <FormMassageTherapyProviderLicenseEntry />
        <FormReasonEntry />
        <FormReasonAdditionalEntry />
        <FormCommentInformation />
        <FormCommentEntry />
        <FormFiles />
        {formType === 'MassageTherapyClaim' ? <FormMassageTherapyProofOfPaymentCashSelector /> : null}
        {formType === 'MassageTherapyClaim' && values.ProofOfPaymentCashSelector === 'NO' ? <FormMassageTherapyProofOfPayment /> : null}
        <FormOtherInsuranceHeading />
        <FormOtherInsuranceSelector />
        <FormOtherInsurancePersonIssued />
        <FormOtherInsuranceDependentsNames />
        <FormOtherInsuranceCompanyName />
        <FormOtherInsuranceCompanyClaimsAddress />

        <FormOtherInsurancePolicyEffectiveDate />
        <FormOtherInsuranceActiveEmploymentFlag />
        <FormOtherInsuranceEmploymentEffectiveDate />
        <FormOtherInsurancePolicyNumber />
        <FormOtherInsurancePolicyCoverageType />
        <FormOtherInsurancePolicyContractType />

        <Divider style={{width: '100%', marginTop: 20, marginBottom: 20}} />
        <FormDeclarationSelector />
        <FormTrackingInformation />
      </React.Fragment>
    )
  }

  function ErrorsNotification({errors, touched}) {
    if ((errors && Object.keys(errors).length > 0 && touched && Object.keys(touched).length > 0) || (errors && errors.PersonFiles)) {
      return (
        <>
          <Card.Body>
            <div className='errors-list'>
              <h4 className='errors-list-heading'>Please fix the following fields before you submit:</h4>
              <ul>
                {Object.keys(errors).map((msg) => (
                  <React.Fragment key={msg}>{touched[msg] || msg === 'PersonFiles' ? <li>{errors[msg]}</li> : null}</React.Fragment>
                ))}
              </ul>
            </div>
          </Card.Body>
        </>
      )
    } else {
      return null
    }
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        key={lastClaimSubmitted?.memberTrackingInfo || 'form'}
        initialValues={{
          FormType: claimType && claimType === 'mtc' ? 'MassageTherapyClaim' : 'ClaimsNoQuestions',
          ReasonEntry:
            useLastClaimSubmitted && lastClaimSubmitted
              ? formType === 'MassageTherapyClaim'
                ? lastClaimSubmitted.massageDescription
                : formType === 'ClaimsNoQuestions' || formType === 'ClaimsWithQuestions' || formType === 'ClaimsHBO'
                ? lastClaimSubmitted.reasonEntry
                : ''
              : '',
          otherFieldName: '',
          ReasonEntryOther: useLastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.reasonOtherEntry : '',
          ReasonAdditionalEntry: useLastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.reasonAdditionalEntry : '',
          ReasonAdditionalEntryOther: useLastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.reasonAdditionalEntryOther : '',
          Comments: '',
          CommentEntry: useLastClaimSubmitted && lastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.comments : '',
          FsbpId: '',
          ServiceCountry: useLastClaimSubmitted && lastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.countryOfService : previousServiceCountry,
          MassageTherapyProvider: useLastClaimSubmitted && lastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.massageName : '',
          MassageTherapyProviderAddress: useLastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.massageAddress : '',
          MassageTherapyProviderLicense: useLastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.massageLicense : '',
          ProofOfPaymentCashSelector: useLastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.massageCashPaid : 'NO',
          TrackingInformation: useLastClaimSubmitted && lastClaimSubmitted ? lastClaimSubmitted.memberTrackingInfo : '',
          HBO: hbo.length > 0 ? hbo[0].id : '',
          Declaration: '0',
          PersonClaim: 'P' + authState.member_key,
          ...otherInsurance
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          setIsLoading(true)
          Savesubmit(values)
        }}
      >
        {(props) => {
          const {errors, values, touched, handleSubmit} = props

          const isCountryMismatch = values.ServiceCountry && countryOfResidence && values.ServiceCountry !== countryOfResidence && values.PersonClaim === 'P' + authState.member_key
          return (
            <form
              noValidate={true}
              autoComplete='off'
              onSubmit={(e) => {
                e.preventDefault()
                if (e.type !== 'keydown' || (e.target && e.target.type === 'submit')) {
                  handleSubmit(e)
                }
              }}
            >
              <Row className='mb-5'>
                <Col xs={12} md={9}>
                  <Grid container spacing={1}>
                    {showWarning && (
                      <Grid item xs={12} md={12}>
                        <Box sx={{width: '100%', py: 1}}>
                          <Alert
                            severity='warning'
                            action={
                              <IconButton aria-label='close' color='inherit' size='small' onClick={() => setShowWarning(false)}>
                                <CloseIcon fontSize='inherit' />
                              </IconButton>
                            }
                            sx={{
                              width: '100%',
                              alignItems: 'flex-start',
                              mx: 'auto',
                              maxWidth: '100%',
                              fontSize: '1rem'
                            }}
                          >
                            <Box sx={{width: '100%'}} className='experience-issues-text'>
                              <AlertTitle sx={{fontSize: '1.1rem', fontWeight: 'bold'}}>Note the Claim Submission process has been updated with new categories and options.</AlertTitle>
                            </Box>
                          </Alert>
                        </Box>
                      </Grid>
                    )}
                    {isCountryMismatch && corWarning && (
                      <Grid item xs={12}>
                        <Box sx={{width: '100%', py: 1}}>
                          <Alert
                            severity='warning'
                            action={
                              <IconButton aria-label='close' size='small' onClick={() => dispatch(Member.actions.setCORWarning(false))}>
                                <CloseIcon fontSize='inherit' />
                              </IconButton>
                            }
                          >
                            <AlertTitle sx={{fontSize: '1.1rem', fontWeight: 'bold'}}>Note your service Country is different from your country of residence. Please update your profile</AlertTitle>
                          </Alert>
                        </Box>
                      </Grid>
                    )}
                    <Grid item xs={12} md={12}>
                      <p className='claim-text'>Please select your claim type then select the name of the person who the claim is being filed for.</p>
                      <p className='claim-text mb-5'>
                        Next, select the appropriate reason category, select the diagnosis option, take a picture of, or browse for the documents you wish to upload and click Submit to send your
                        claim.
                      </p>
                      <Alert severity='info' className='claim-text'>
                        All PDF file submissions are converted to grayscale. Please make sure the PDF document uploaded is in Portable Document Format (PDF). If the claim submission is failing, try
                        submitting one document at a time to identify the failing document.{' '}
                      </Alert>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Card>
                        <Card.Body>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <FormControl variant='outlined' margin='dense' style={{margin: '14px 0 6px 0', minWidth: '100%'}}>
                                <InputLabel shrink id='claimselect-label'>
                                  Select Claim Type
                                </InputLabel>
                                <Select
                                  aria-label='Select Claim Type'
                                  id='claimselect'
                                  name='claimselect'
                                  onChange={handleClaimTypeChange}
                                  defaultValue={claimType && claimType ? claimType : 'cnq'}
                                  label='Select Claim Type'
                                  labelId='claimselect-label'
                                >
                                  <MenuItem key={'cnq'} value={'cnq'}>
                                    Claim Without Questions
                                  </MenuItem>
                                  <MenuItem key={'mtc'} value={'mtc'}>
                                    Massage Therapy Claim
                                  </MenuItem>
                                  <MenuItem key={'cwq'} value={'cwq'}>
                                    Claim With Questions
                                  </MenuItem>
                                  <MenuItem key={'cdh'} value={'cdh'}>
                                    Claim Directed to Specific HBO
                                  </MenuItem>
                                  <MenuItem key={'cov'} value={'cov'}>
                                    Claim for COVID-19 Over the Counter Testing Kits
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Button
                                variant='contained'
                                size='large'
                                className='w-50'
                                onClick={() => setUseLastClaimSubmitted(true)}
                                style={{background: '#E6F5FF', color: '#0074A6', marginTop: '14px', paddingTop: '12px', paddingBottom: '12px'}}
                                disableElevation
                              >
                                <span style={{fontSize: '16px'}}>Prefill from Last Claim Submission</span>
                              </Button>
                            </Grid>
                          </Grid>
                        </Card.Body>
                      </Card>
                    </Grid>
                  </Grid>
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col xs={12} md={9}>
                  <Card>
                    <Card.Body>
                      <Grid container spacing={1}>
                        <DisplayQuestions />
                      </Grid>
                    </Card.Body>
                    <Divider />
                    <ErrorsNotification errors={errors} touched={touched} />

                    <Card.Body>
                      <Box component='div' sx={{display: {xs: 'none', md: 'block'}}}>
                        <Grid container xs={12} gap={3} justifyContent={'end'}>
                          <Link to='/home'>
                            <Button variant='contained' size={'large'} style={{background: '#E6F5FF', color: '#0074A6'}} disableElevation>
                              Cancel
                            </Button>
                          </Link>
                          <Button variant='contained' size={'large'} color='primary' type='submit' disableElevation disabled={isLoading} style={{background: '#0074A6'}}>
                            Submit Claim
                          </Button>
                        </Grid>
                      </Box>

                      <Box component='div' sx={{display: {xs: 'block', md: 'none'}}}>
                        <Grid container xs={12} justifyContent={'space-between'}>
                          <Grid item className={'pr-2'} xs={6}>
                            <Link to='/home'>
                              <Button variant='contained' size={'large'} className={'w-100'} style={{background: '#E6F5FF', color: '#0074A6'}} disableElevation>
                                Cancel
                              </Button>
                            </Link>
                          </Grid>
                          <Grid item className={'pl-2'} xs={6}>
                            <Button variant='contained' size={'large'} className={'w-100'} color='primary' type='submit' disableElevation disabled={isLoading} style={{background: '#0074A6'}}>
                              Submit Claim
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </form>
          )
        }}
      </Formik>

      <Dialog open={open} aria-labelledby='Submitting Claim Please Wait' fullWidth={true} maxWidth='sm'>
        <DialogTitle>Submitting Claim</DialogTitle>
        <DialogContent style={{paddingTop: 30, paddingBottom: 30}}>
          {/* Check for result of submitting claim */}
          {returnStatus && returnStatus.length > 0 ? (
            <>
              {returnStatus === 'OK' ? (
                <Card>
                  <Card.Body>
                    <div className='mb-2 bg-light-primary p-8 rounded self-stretch'>
                      <div className='text-primary'>
                        <strong style={{fontSize: 15}}>Claim Submitted Successfully</strong>
                        <p className='claim-text' style={{marginTop: 20}}>
                          Thank you for securely submitting your claim. You can view this submission immediately in your claim history within your Member Portal account. Claims are stored in your
                          account for three years from the date of upload.
                        </p>
                        <p className='claim-text'>Domestic claims are typically processed within 30 days of receipt, while foreign claims take about 10 to 14 business days.</p>
                        <p className='claim-text'>If additional information is required, please upload it in the same way you submitted your claim.</p>
                        <p className='claim-text'>
                          You can check the status of your claims by visiting the Aetna Member Secure Website through the
                          <span style={{textDecoration: 'underline', textDecorationColor: 'blue', color: 'blue'}}>
                            <a href={aetnasso && aetnasso} target='_blank' rel='noopener noreferrer'>
                              {' Member Portal`s Single Sign On (SSO).'}
                            </a>
                          </span>
                          or by accessing the website directly at <a href='https://www.aetna.com'>www.aetna.com</a>.{' '}
                        </p>
                        <p className='claim-text'>If you haven`t registered for the Aetna Member Secure Website yet, we encourage you to do so.</p>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Body>
                    <Box component='div' sx={{display: {xs: 'none', md: 'block'}}}>
                      <Grid container xs={12} gap={2} justifyContent={'center'}>
                        <Link to='/claims-history'>
                          <Button variant='contained' size={'large'} color='primary' disableElevation style={{background: '#0074A6'}}>
                            View Claims History
                          </Button>
                        </Link>
                        <Link reloadDocument to='/submit-claim'>
                          <Button variant='contained' size={'large'} color='primary' disableElevation style={{background: '#0074A6'}}>
                            Add More Claims
                          </Button>
                        </Link>
                        <Link to='/home'>
                          <Button variant='contained' size={'large'} color='primary' disableElevation style={{background: '#0074A6'}}>
                            Return to Home
                          </Button>
                        </Link>
                      </Grid>
                    </Box>

                    <Box component='div' sx={{display: {xs: 'block', md: 'none'}}}>
                      <Grid container xs={12} justifyContent={'space-between'}>
                        <Grid item className={'pr-13'} xs={4}>
                          <Link to='/claims-history'>
                            <Button variant='contained' size={'large'} className={'w-100'} color='primary' disableElevation style={{background: '#0074A6'}}>
                              View Claims History
                            </Button>
                          </Link>
                        </Grid>
                        <Grid item className={'pl-3'} xs={4}>
                          <Link reloadDocument to='/submit-claim'>
                            <Button variant='contained' size={'large'} className={'w-100'} color='primary' disableElevation style={{background: '#0074A6'}}>
                              Add More Claims
                            </Button>
                          </Link>
                        </Grid>
                        <Grid item className={'pl-3'} xs={4}>
                          <Link to='/home'>
                            <Button variant='contained' size={'large'} className={'w-100'} color='primary' disableElevation style={{background: '#0074A6'}}>
                              Return to Home
                            </Button>
                          </Link>
                        </Grid>
                      </Grid>
                    </Box>
                  </Card.Body>
                </Card>
              ) : (
                <Card>
                  <Card.Body>
                    <div className='mb-2 bg-light-danger p-8 rounded self-stretch'>
                      <div className='text-danger'>
                        <strong>{returnStatus}</strong>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Body>
                    <Box component='div' sx={{display: {xs: 'none', md: 'block'}}}>
                      <Grid container xs={12} gap={3} justifyContent={'end'}>
                        <Link to='/home'>
                          <Button variant='contained' size={'large'} style={{background: '#E6F5FF', color: '#0074A6'}} disableElevation>
                            Return to Home
                          </Button>
                        </Link>
                        <Button variant='contained' size={'large'} color='primary' type='submit' disableElevation style={{background: '#0074A6'}} onClick={() => allowMoreEditing()}>
                          Edit and Resubmit Claim
                        </Button>
                      </Grid>
                    </Box>

                    <Box component='div' sx={{display: {xs: 'block', md: 'none'}}}>
                      <Grid container xs={12} justifyContent={'space-between'}>
                        <Grid item className={'pr-2'} xs={6}>
                          <Link to='/home'>
                            <Button variant='contained' size={'large'} className={'w-100'} style={{background: '#E6F5FF', color: '#0074A6'}} disableElevation>
                              Return to Home
                            </Button>
                          </Link>
                        </Grid>
                        <Grid item className={'pl-2'} xs={6}>
                          <Button variant='contained' size={'large'} className={'w-100'} color='primary' disableElevation style={{background: '#0074A6'}} onClick={() => allowMoreEditing()}>
                            Edit and Resubmit Claim
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Card.Body>
                </Card>
              )}
            </>
          ) : (
            <DialogContentText>
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait while we process your submission... <Spinner animation='border' className='bc-sync-spinner' size='sm' variant='light' />
              </span>
            </DialogContentText>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
